import { unifiedColors as colors } from '@miles/ui/colors'

export const unifiedColors = {
  ...colors
}
